import { authorizedApiClient } from "../config";
import {
  CreateAutomation, ReadAllAutomations, ReadAllAutomationsResponse,
  ReadAutomation, ReadLogsById, ReadLogsByIdResponse, UpdateAutomation,
} from "./automationEndpoints.interface";

export const createAutomation = async ({
  name,
  description,
  trigger,
  entity_relation,
  automation_type,
  is_precreated,
  filters,
  metrics,
  status,
  automation_actions,
  time_window,
  selected_fields,
  time_zone,
  owner_id,
  workspace_id,
  sort,
}: CreateAutomation) => authorizedApiClient.post<CreateAutomation>(`/${workspace_id}/automation`, {
  name,
  description,
  trigger,
  entity_relation,
  automation_type,
  is_precreated,
  filters,
  metrics,
  status,
  automation_actions,
  time_window,
  selected_fields,
  time_zone,
  owner_id,
  workspace_id,
  sort,
});

export const updateAutomation = async ({
  name,
  description,
  trigger,
  entity_relation,
  automation_type,
  is_precreated,
  filters,
  metrics,
  status,
  automation_actions,
  time_window,
  selected_fields,
  time_zone,
  automation_id,
  workspace_id,
  sort,
}: { automation_id: string, workspace_id: string } & UpdateAutomation) => authorizedApiClient.put<CreateAutomation>(`/${workspace_id}/automation/${automation_id}`, {
  name,
  description,
  trigger,
  entity_relation,
  automation_type,
  is_precreated,
  filters,
  metrics,
  status,
  automation_actions,
  time_window,
  selected_fields,
  time_zone,
  sort,
});

export const readAutomation = async ({
  workspace_id,
  automation_id,
}: ReadAutomation) => authorizedApiClient.get<ReadAutomation>(`/${workspace_id}/automation/${automation_id}`);

export const deleteAutomation = async ({
  workspace_id,
  automation_id,
}: ReadAutomation) => authorizedApiClient.delete<void>(
  `/${workspace_id}/automation/${automation_id}`,
);

export const readAllAutomations = async ({
  workspace_id,
  automation_type,
  skip = 0,
  limit = 100,
}: ReadAllAutomations) => authorizedApiClient.get<ReadAllAutomationsResponse>(`/${workspace_id}/automations/all`, {
  params: { automation_type, skip, limit },
});

export const readAutomationLogs = async ({
  workspace_id,
  automation_id,
  status,
  automation_type,
  skip = 0,
  limit = 20,
}: ReadLogsById) => {
  const params: any = {
    skip,
    limit,
  };

  if (workspace_id !== undefined) {
    params.workspace_id = workspace_id;
  }

  if (automation_id !== undefined) {
    params.automation_id = automation_id;
  }

  if (status !== undefined) {
    params.status = status;
  }

  if (automation_type !== undefined) {
    params.automation_type = automation_type;
  }

  return authorizedApiClient.get<ReadLogsByIdResponse>(`/${workspace_id}/automation_logs`, {
    params,
  });
};

export const readSignalAutomations = async ({
  workspace_id,
  automation_id,
  status,
  playbook_id,
  skip = 0,
  limit = 20,
}: {
  workspace_id: string;
  automation_id?: string;
  status?: string;
  playbook_id?: string;
  skip?: number;
  limit?: number;
}) => {
  const params: any = {
    automation_type: "signal",
    action_type: "send_to_inbox",
    skip,
    limit,
  };

  if (automation_id) params.automation_id = automation_id;
  if (status) params.status = status;
  if (playbook_id) params.playbook_id = playbook_id;

  return authorizedApiClient.get<ReadAllAutomationsResponse>(`/${workspace_id}/automations/all`, {
    params,
  });
};
